export class UserNotificationRulesInteraction {
  idNotification: string;
  idUser: string;
  seen: boolean;
  action: string;
  idEquipment: string;
  idSubscription: string;
}
